import React from "react";

export const ContactAreaMap = () => {
  return (
    <div className="contact-map">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3838.328990498419!2d74.501854!3d15.839296999999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTXCsDUwJzIxLjUiTiA3NMKwMzAnMDYuNyJF!5e0!3m2!1sen!2sin!4v1762171035308!5m2!1sen!2sin"
        width="600"
        height="450"
        style={{ border: 0 }}
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
        title="contact-map"
      />
    </div>
  );
};
